import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Button } from '@estee/elc-buttons';
import { ContentSpacing } from '@estee/elc-base-theme';
import { ratingTheme } from '../theme/default-theme';
import * as classnames from 'classnames';
import { RATING_CLICKABLE, RATING_NON_CLICKABLE } from '../constants/DataTestIds';

export interface IRatingWrapper {
    className: string;
    onRatingWrapperClick?(): void;
    isClickable: boolean;
    children: JSX.Element | JSX.Element[];
}

const ratingWrapper = `
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    margin: ${ContentSpacing.space12} 0;
    ${ratingTheme};
`;

const RatingButtonWrapper = styled(Button)`
    ${ratingWrapper}
`;

const RatingDivWrapper = styled.div`
    ${ratingWrapper}
`;

export const RatingWrapper = observer((props: IRatingWrapper) => {
    const { onRatingWrapperClick, className, isClickable, children } = props;

    if (isClickable) {
        return (
            <RatingButtonWrapper
                className={classnames('elc-rating-button', className)}
                onClick={onRatingWrapperClick}
                data-test-id={RATING_CLICKABLE}
            >
                {children}
            </RatingButtonWrapper>
        );
    }

    return (
        <RatingDivWrapper className={className} data-test-id={RATING_NON_CLICKABLE}>
            {children}
        </RatingDivWrapper>
    );
});
